import Axios from 'axios';
import { reportErrorSentry } from 'src/bff';
import { DomainResponse } from 'src/types';
import { getMolecularCdnUrl } from '../get-molecular-cdn-url';

export const fetchProvince = async (token?: string): Promise<DomainResponse> => {
  const molecularCdn = getMolecularCdnUrl();
  const requestToken = token ? token : 'VW_DDB_FRM_LEM_REC_LEM';

  try {
    const response = await Axios.get(`${molecularCdn}/request-dps-domain.php?token=${requestToken}&domain=Province`, {
      timeout: 10000,
    });
    return response.data;
  } catch (err) {
    reportErrorSentry(err);
    return null;
  }
};

export const fetchDealers = async (code: string, token?: string): Promise<DomainResponse> => {
  const molecularCdn = getMolecularCdnUrl();
  const requestToken = token ? token : 'VW_DDB_FRM_LEM_REC_LEM';

  try {
    const response = await Axios.get(
      `${molecularCdn}/request-dps-domain.php?token=${requestToken}&domain=Installation&relatedDomain=FRML_TXT_codVentaProvincia__c&relatedValue=${code}`,
      { timeout: 10000 }
    );
    return response.data;
  } catch (err) {
    reportErrorSentry(err);
    return null;
  }
};

export const fetchTreatment = async (token?: string): Promise<DomainResponse> => {
  const molecularCdn = getMolecularCdnUrl();
  const requestToken = token ? token : 'VW_DDB_FRM_LEM_REC_LEM';

  try {
    const response = await Axios.get(`${molecularCdn}/request-dps-domain.php?token=${requestToken}&domain=Treatment`, {
      timeout: 10000,
    });
    return response.data;
  } catch (err) {
    reportErrorSentry(err);
    return null;
  }
};
